function throttle(callback) {
    let requestId = null,
        lastArgs;
    const later = context => () => {
            requestId = null, callback.apply(context, lastArgs)
        },
        throttled = (...args) => {
            lastArgs = args, requestId === null && (requestId = requestAnimationFrame(later(this)))
        };
    return throttled.cancel = () => {
        cancelAnimationFrame(requestId), requestId = null
    }, throttled
}
var ImagesWithTextScrolling = class extends HTMLElement {
    connectedCallback() {
        window.addEventListener("beforeunload",function(){
          window.scrollTo(0,0);
        })
        this.hasAttribute("scrolling-experience") && (this._imageToTransitionItems = Array.from(this.querySelectorAll(".images-scrolling-desktop__media-wrapper > :not(:first-child)")), this._mainImage = this.querySelector(".images-scrolling-desktop__media-wrapper > :first-child"), this._contentItems = Array.from(this.querySelectorAll(".images-scrolling__content")), this._imageToTransitionItems.length > 0 && window.addEventListener("scroll", throttle(this._onScroll.bind(this))))
    }
    _onScroll() {
        const imageRect = this._mainImage.getBoundingClientRect(),
            imageBottom = imageRect.bottom,
            imageEffect = this.getAttribute("scrolling-experience");
        for (const [index, contentItem] of this._contentItems.entries()) {
            const contentItemRect = contentItem.getBoundingClientRect(),
                image = this._imageToTransitionItems[index - 1],
                content = this._contentItems[index];
            if (contentItemRect.top < imageBottom - imageRect.height * .15 && contentItemRect.bottom > imageBottom) {
                image && !image.classList.contains("is-visible") && 
                  (image.classList.add("is-visible"));
                break
            }
            if (contentItemRect.top > imageBottom - imageRect.height * .15) {
                image && image.classList.contains("is-visible") && 
                  (image.classList.remove("is-visible"));
                break
            }
        }
    }
};
window.customElements.get("images-with-text-scrolling") || window.customElements.define("images-with-text-scrolling", ImagesWithTextScrolling);